<script lang="ts" setup>
import type { Question } from '~/types/Feedback';

const isShowModal = defineModel<boolean>({ default: false });

defineEmits(['submit-reply']);
defineProps<{ question: Question }>();
const catalogStore = useCatalogStore();

const productCatalogImage = computed(() => {
  if (catalogStore.selectedOffer) {
    return (
      catalogStore.selectedOffer.offer_images.find((image) => image.is_main) ??
      catalogStore.selectedOffer.offer_images[0]
    );
  }
  return null;
});
</script>

<template>
  <BaseModal
    v-model="isShowModal"
    title="Ответ на вопрос о товаре"
    @close="isShowModal = false"
  >
    <section class="add-question-modal">
      <div class="flex gap-6 items-center">
        <picture
          v-if="productCatalogImage"
          class="size-20 object-contain rounded-xl"
        >
          <source
            :srcset="productCatalogImage.conversions_webp.thumb_url_360"
            type="image/webp"
          />
          <source
            :srcset="productCatalogImage.conversions.thumb_url_360"
            type="image/jpeg"
          />
          <img
            :alt="catalogStore.selectedOffer.product_name"
            :src="productCatalogImage.url"
            class="w-full h-full object-contain"
          />
        </picture>

        <div v-else>
          <SvgoNoPhotoSmall
            :font-controlled="false"
            class="size-14"
            filled
          />
        </div>

        <div>{{ catalogStore.selectedOffer.product_name }}</div>
      </div>

      <div class="font-bold text-xl">
        {{ question.message }}
      </div>

      <ProductPageAddReplyForm
        :question-id="question.id"
        @close-modal="isShowModal = false"
        @submit-reply="$emit('submit-reply')"
      />
    </section>
  </BaseModal>
</template>

<style lang="scss" scoped>
.add-question-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 12px;
}
</style>
